import { Command } from 'commands/Commands';

export class AddPartner extends Command {
  type: string = 'Partner.Add';

  priority: number = 100;
}
